/** @format */

import { ConnectionPositionPair, Overlay, OverlayConfig, OverlayRef } from "@angular/cdk/overlay";
import { TemplatePortal } from "@angular/cdk/portal";
import { Directive, ElementRef, HostListener, Input, TemplateRef, ViewContainerRef } from "@angular/core";
import { take } from "rxjs/operators";

@Directive({
  selector: "[misEmployeeWebExpMenu]"
})
export class MenuDirective {
  @Input("misEmployeeWebExpMenu") menu: TemplateRef<ElementRef>;
  @Input() positionX: "start" | "end" = "start";
  @Input() positionY: "top" | "bottom" = "bottom";
  @Input() offsetX = 0;
  @Input() offsetY = 0;
  private overlayRef: OverlayRef;

  constructor(private overlay: Overlay, private element: ElementRef, private viewContainerRef: ViewContainerRef) {}
  @HostListener("click", ["$event"]) onClick(event) {
    this.menuShow();
  }
  private menuShow() {
    const positionStrategy = this.overlay
      .position()
      .flexibleConnectedTo(this.element)
      .withPositions([
        new ConnectionPositionPair(
          { originX: this.positionX, originY: this.positionY },
          { overlayX: this.positionX, overlayY: this.positionY === "bottom" ? "top" : "bottom" },
          this.offsetX,
          this.offsetY
        ),
        new ConnectionPositionPair({ originX: "start", originY: "bottom" }, { overlayX: "start", overlayY: "top" }, this.offsetX, this.offsetY),
        new ConnectionPositionPair({ originX: "end", originY: "top" }, { overlayX: "end", overlayY: "bottom" }, this.offsetX, this.offsetY)
      ])
      .withPush(true);
    const config = new OverlayConfig({
      hasBackdrop: true,
      positionStrategy,
      scrollStrategy: this.overlay.scrollStrategies.reposition(),
      backdropClass: "cdk-overlay-transparent-backdrop"
    });
    this.overlayRef = this.overlay.create(config);

    const tempRef = new TemplatePortal(this.menu, this.viewContainerRef);
    this.overlayRef.attach(tempRef);
    this.overlayRef
      .backdropClick()
      .pipe(take(1))
      .subscribe(res => {
        this.close();
      });
  }

  close(): void {
    this.overlayRef?.detach();
    this.overlayRef?.dispose();
  }
}
